export default function map(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index) => mapper(value, index, values));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/map.js
// module id = 419
// module chunks = 0